<template lang="html">
  <div class="level">
    <div class="level-item has-text-centered">
      <div class="loader" :class="size"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {type: String, default: null}
  }
}
</script>

<style scoped>
  .loader.is-large{
    width: 3em;
    height: 3em
  }
  .loader.is-medium{
    width: 2em;
    height: 2em
  }
  .loader.is-inverted{
    border-bottom-color: #6b6a6b;
    border-left-color: #6b6a6b;
  }
</style>



// WEBPACK FOOTER //
// shared/components/LoadingIndicator.vue